import { signal } from '@preact/signals'

import api, { ApiError } from './api'

// profile: undefined while loading, null when logged out.
export const profile = signal(undefined)

export async function loadProfile() {
  try {
    profile.value = await api.get('/api/me')
  } catch (error) {
    if (error instanceof ApiError && error.status === 401)
      profile.value = null
    else
      throw error
  }

  return profile.value
}

export async function setDisplayName(displayName) {
  const res = await api.post('/api/me', { displayName })
  profile.value = res.state.profile

  return res
}

export async function devLogin(email) {
  const res = await api.post('/auth/dev-login', { email })
  profile.value = res.state.profile

  return res
}

export async function logout() {
  await api.post('/auth/logout')
  profile.value = null
}
